import { createApiRef } from "@backstage/core-plugin-api";

import type {
  DeploymentRequest,
  DeploymentResponse,
  Service,
  DeploymentsListResponse,
  DeploymentStatusResponse,
  RemoveDeployedInstanceResponse,
} from "./types";

export interface OrchestratorApi {
  deploy(request: DeploymentRequest): Promise<DeploymentResponse>;
  getAvailableServices(): Promise<Service[]>;
  getRepoServiceSuggestions(options?: { query?: string; limit?: number }): Promise<string[]>;
  getAvailableVersions(serviceName: string): Promise<string[]>;
  getSuggestedVersions(
    serviceName: string,
    options?: { query?: string; limit?: number },
  ): Promise<string[]>;
  getSquads(): Promise<string[]>;
  getDeployments(filters?: {
    environment?: string | string[];
    status?: string | string[];
    lifecycleStatus?: string;
    triggered_by?: string;
    name?: string;
    squad?: string | string[];
    limit?: number;
    offset?: number;
  }): Promise<DeploymentsListResponse>;
  getDeploymentStatus(deploymentId: string): Promise<DeploymentStatusResponse>;
  removeDeployedInstance(deploymentId: string): Promise<RemoveDeployedInstanceResponse>;
}

export const orchestratorApiRef = createApiRef<OrchestratorApi>({
  id: "plugin.orchestrator.api",
});
